import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";

export const getRouter = () => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        // CRITICAL: Disabling refetchOnWindowFocus prevents ALL queries from
        // refiring when the user clicks an input box (which triggers a window
        // focus event). On cold-start Render.com backend, this caused a page freeze.
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        retry: 1,
        staleTime: 30_000, // 30s — don't re-fetch data that's already fresh
      },
    },
  });

  const router = createRouter({
    routeTree,
    context: { queryClient },
    scrollRestoration: true,
    defaultPreloadStaleTime: 0,
  });

  return router;
};
